import { styled } from '@bob/library'

export const PlayButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  > svg > path {
    opacity: 0.6;
  }
  :hover {
    > svg > path {
      opacity: 1;
    }
  }
  @media print {
    display: none;
  }

  &.playing {
    display: none;
  }
`

export const VideoWrapper = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: inherit;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 800ms;
  transition-delay: 0ms;

  &.playing {
    transition-delay: 0ms;
    opacity: 1;
  }
`

export const VideoRatioContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  transition: transform 400ms;
`

export const VideoIframe = styled.iframe<{ isPlaying: boolean; isFullscreen: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  // allow pointer events so we can use the video controls when it is playing
  // but otherwise use 'none' so it doesn't block clicking other elements
  pointer-events: ${({
    isPlaying,
    isFullscreen,
  }: { isPlaying: boolean } & { isFullscreen: boolean }) =>
    isPlaying || isFullscreen ? 'all' : 'none'};
`
